const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/layout/PickersUtilsProvider.tsx';
import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { deDE, enUS, frFR, itIT } from '@mui/x-date-pickers/locales';
import { selLocale } from '../selectors/i18nSelectors';

interface Props {
    children: ReactNode;
}

type PickerLocaleTextObject = Readonly<typeof enUS.components.MuiLocalizationProvider.defaultProps.localeText>;

function getDatePickerTranslationObject(locale: string) {
    switch (locale) {
        case 'en':
            return enUS;
        case 'fr':
            return frFR;
        case 'it':
            return itIT;
        default:
            return deDE;
    }
}

export function usePickerLocaleTextObject(): PickerLocaleTextObject | undefined {
    const locale = useSelector(selLocale);
    const tro = getDatePickerTranslationObject(locale);
    return tro?.components?.MuiLocalizationProvider?.defaultProps?.localeText;
}

const PickersUtilsProvider = (props: Props) => {
    const localeText = usePickerLocaleTextObject();
    return (
        <LocalizationProvider dateAdapter={AdapterMoment} localeText={localeText}>
            {props.children}
        </LocalizationProvider>
    );
};

export default PickersUtilsProvider;
